"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = exports.BOOKING_STATES = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../KESI2/KESI2BasicComponent"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _Card = _interopRequireDefault(require("@material-ui/core/Card"));

var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));

var _KESI2Helper = _interopRequireDefault(require("../../../KESI2/KESI2Helper"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _DateTimeHelper = require("../../../helpers/DateTimeHelper");

var _DrupalRubric = _interopRequireDefault(require("./DrupalRubric.scss"));

var _DrupalRubricStrings = require("./DrupalRubricStrings");

var _MuiAlertHelper = require("../../../helpers/MuiAlertHelper");

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _UserProfile = _interopRequireDefault(require("../UserInfo/UserProfile"));

var _RegisterInstance = _interopRequireDefault(require("../../../KESI2/Services/RegisterInstance"));

var _HttpRequest = require("../../../utils/HttpRequest");

var _BuildConstants = require("../../../utils/BuildConstants");

var _ErrorHelper = require("../../../helpers/ErrorHelper");

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _ArrayHelper = require("../../../helpers/ArrayHelper");

var _DrupalEventSeries = require("./DrupalEventSeries");

var _PreconditionChecker = require("../../../utils/PreconditionChecker");

var _Image = _interopRequireDefault(require("../Image/Image"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var BOOKING_URL = 'rest/v1/event/_changeState';
var BOOKING_STATES = {
  BOOKED: 'booked',
  RESERVED: 'reserved',
  CANCELED: 'canceled',
  FINISHED: 'finished'
};
exports.BOOKING_STATES = BOOKING_STATES;

var DrupalEventDate = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalEventDate, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalEventDate);

  function DrupalEventDate(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, DrupalEventDate);
    _this = _super.call(this, props, context, props.eventDateId);
    /*
    KESI2BasicComponent also defines state, in order to keep DrupalLecture state
    and the already initialized Kesi2BasicComponent state we use ...this.state here.
    If we dont do that keys like "course" will be overridden to be null resulting in an app crash.
     */

    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "innerForceUpdate", function () {
      _this.forceUpdate();
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "updateBookingStateOnServer", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(eventDate, bookingState) {
        var tokenPromise, response, prevBookedEventIds, tagArray, _tagArray;

        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                tokenPromise = _RegisterInstance["default"].getAccessToken('event:book');
                _context3.t0 = _HttpRequest.httpPut;
                _context3.t1 = "".concat(_BuildConstants.SEMINARS_HOST, "/").concat(BOOKING_URL);
                _context3.t2 = {
                  id: eventDate.uuid,
                  state: bookingState
                };
                _context3.next = 7;
                return tokenPromise;

              case 7:
                _context3.t3 = _context3.sent;
                _context3.t4 = 'Bearer ' + _context3.t3;
                _context3.next = 11;
                return (0, _context3.t0)(_context3.t1, _context3.t2, null, null, 10, _context3.t4);

              case 11:
                response = _context3.sent;
                // any 200 response is success
                prevBookedEventIds = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.BOOKED_EVENT_DATES) || [];

                if (!(bookingState === BOOKING_STATES.BOOKED)) {
                  _context3.next = 19;
                  break;
                }

                _context3.next = 16;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.BOOKED_EVENT_DATES, prevBookedEventIds.concat(eventDate.id));

              case 16:
                if (eventDate.bookingTags) {
                  tagArray = eventDate.bookingTags.split(',');
                  tagArray.forEach( /*#__PURE__*/function () {
                    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(singleTag) {
                      var storedTags, index, storedMobileTags, mobileIndex;
                      return _regenerator["default"].wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              storedTags = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.BOOKING_TAGS) || [];
                              index = storedTags.indexOf(singleTag);
                              storedMobileTags = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.MOBILE_BOOKING_TAGS) || [];
                              mobileIndex = storedMobileTags.findIndex(function (tag) {
                                return tag.name === singleTag;
                              });

                              if (!(index < 0)) {
                                _context.next = 7;
                                break;
                              }

                              _context.next = 7;
                              return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.BOOKING_TAGS, storedTags.concat(singleTag));

                            case 7:
                              if (!(mobileIndex < 0)) {
                                _context.next = 10;
                                break;
                              }

                              _context.next = 10;
                              return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.MOBILE_BOOKING_TAGS, storedMobileTags.concat({
                                name: singleTag
                              }));

                            case 10:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    return function (_x3) {
                      return _ref2.apply(this, arguments);
                    };
                  }());
                }

                _context3.next = 23;
                break;

              case 19:
                if (!(bookingState === BOOKING_STATES.CANCELED)) {
                  _context3.next = 23;
                  break;
                }

                _context3.next = 22;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.BOOKED_EVENT_DATES, (0, _ArrayHelper.removeElementFromCopy)(prevBookedEventIds, eventDate.id));

              case 22:
                if (eventDate.bookingTags) {
                  _tagArray = eventDate.bookingTags.split(',');

                  _tagArray.forEach( /*#__PURE__*/function () {
                    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(singleTag) {
                      var storedTags, index, storedMobileTags, mobileIndex;
                      return _regenerator["default"].wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              storedTags = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.BOOKING_TAGS) || [];
                              index = storedTags.indexOf(singleTag);
                              storedMobileTags = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.MOBILE_BOOKING_TAGS) || [];
                              mobileIndex = storedMobileTags.findIndex(function (tag) {
                                return tag.name === singleTag;
                              });
                              console.log('INFO', 'DrupalEventDate.updateBookingStateOnServer', 'canceling event date', storedTags, index, storedMobileTags, mobileIndex);

                              if (!(index > -1)) {
                                _context2.next = 9;
                                break;
                              }

                              (0, _ArrayHelper.removeElementAtPosition)(storedTags, index);
                              _context2.next = 9;
                              return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.BOOKING_TAGS, storedTags);

                            case 9:
                              if (!(mobileIndex > -1)) {
                                _context2.next = 13;
                                break;
                              }

                              (0, _ArrayHelper.removeElementAtPosition)(storedMobileTags, mobileIndex);
                              _context2.next = 13;
                              return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.MOBILE_BOOKING_TAGS, storedMobileTags);

                            case 13:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2);
                    }));

                    return function (_x4) {
                      return _ref3.apply(this, arguments);
                    };
                  }());
                }

              case 23:
                _this.notifyParent();

                _context3.next = 30;
                break;

              case 26:
                _context3.prev = 26;
                _context3.t5 = _context3["catch"](0);
                console.error('ERROR', 'DrupalEventDate.updateBookingStateOnServer', 'booking event date: ' + eventDate.uuid, _context3.t5);
                (0, _MuiAlertHelper.showAlertWithOptions)({
                  title: (0, _DrupalRubricStrings.getString)('ERROR'),
                  message: (0, _ErrorHelper.getErrorMessage)(_context3.t5)
                });

              case 30:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 26]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    _this.state = _objectSpread({
      ownBookingState: null
    }, _this.state);
    _this.currentUpdateValue = props.updateValue;

    _this.setDataStorePaths([_DataStore.DATA_STORE_PATHS.BOOKED_EVENT_DATES]);

    return _this;
  }

  (0, _createClass2["default"])(DrupalEventDate, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalEventDate.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);

      if ((0, _stringify["default"])(prevProps.contentPathArray) !== (0, _stringify["default"])(this.props.contentPathArray) || this.props.updateValue !== this.currentUpdateValue) {
        this.currentUpdateValue = this.props.updateValue;
      }

      if (this.props.updateValue !== prevProps.updateValue) {
        console.log('INFO', 'DrupalEventDate.componentDidUpdate', 'update value changed', 'call loadBookingState)', prevProps.updateValue, this.props.updateValue); // reload state as this eventDate is shown under myEvents and was hidden and shown again

        this.loadBookingState();
      }

      if ((0, _stringify["default"])(prevState.data[_DataStore.DATA_STORE_PATHS.BOOKED_EVENT_DATES]) !== (0, _stringify["default"])(this.state.data[_DataStore.DATA_STORE_PATHS.BOOKED_EVENT_DATES])) {
        // don't wait
        console.log('INFO', 'DrupalEventDate.componentDidUpdate', 'call load bookingstate');
        this.loadBookingState();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_DeviceInfoHelper["default"].isBrowser()) {
        window.screen.orientation.addEventListener('change', this.innerForceUpdate);
      }

      if (!this.props.eventDateStates) {
        this.loadBookingState();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalEventDate.prototype), "componentWillUnmount", this).call(this);

      if (!_DeviceInfoHelper["default"].isBrowser()) {
        window.screen.orientation.removeEventListener('change', this.innerForceUpdate);
      }
    }
    /**
     * This function is basically copied from DrupalEventSeries
     * @returns {Promise<void>}
     */

  }, {
    key: "loadBookingState",
    value: function () {
      var _loadBookingState = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var eventDate, singleEventSeries, tokenPromise, response, bookingState;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                /**
                 * @type EventDate
                 */
                eventDate = this.state.content[this.props.eventDateId];
                singleEventSeries = _KESI2Helper["default"].getEventSeriesByEventDateId(this.props.eventDateId);

                if (singleEventSeries) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt("return");

              case 4:
                _context4.prev = 4;
                tokenPromise = _RegisterInstance["default"].getAccessToken('course:read');
                _context4.t0 = _HttpRequest.httpGet;
                _context4.t1 = "".concat(_BuildConstants.SEMINARS_HOST, "/").concat(_DrupalEventSeries.GET_EVENT_SERIES_DETAILS_URL);
                _context4.t2 = {
                  ids: singleEventSeries.uuid
                };
                _context4.next = 11;
                return tokenPromise;

              case 11:
                _context4.t3 = _context4.sent;
                _context4.t4 = 'Bearer ' + _context4.t3;
                _context4.next = 15;
                return (0, _context4.t0)(_context4.t1, _context4.t2, null, null, 10, _context4.t4);

              case 15:
                response = _context4.sent;
                console.log('INFO', 'DrupalEventDate.loadBookingState', 'booking state', response);

                if (response && response.data) {
                  bookingState = response.data; // let localBookingState = this.state.data[DATA_STORE_PATHS.BOOKED_EVENT_DATES] || []
                  // let localBookingStateChanged = false
                  //
                  // localBookingState.forEach(dateId => {
                  //   const content = KESI2Helper.getContentById(dateId)
                  //   const eventContent = KESI2Helper.getEventSeriesByEventDateId(dateId)
                  //   const uuidToFind = content.uuid
                  //   if (!bookingState[eventContent.uuid] || (bookingState[eventContent.uuid] && !bookingState[eventContent.uuid][uuidToFind])) {
                  //     localBookingState = removeElementFromCopy(localBookingState, dateId)
                  //     localBookingStateChanged = true
                  //   }
                  // })
                  //
                  // if (localBookingStateChanged) {
                  //   DataStore.setSingleData(DATA_STORE_PATHS.BOOKED_EVENT_DATES, localBookingState)
                  // }

                  if (bookingState[singleEventSeries.uuid] && bookingState[singleEventSeries.uuid][eventDate.uuid]) {
                    console.log('INFO', 'DrupalEventDate.loadBookingState', 'set local state');
                    this.setState({
                      ownBookingState: bookingState[singleEventSeries.uuid][eventDate.uuid]
                    });
                  }
                }

                _context4.next = 24;
                break;

              case 20:
                _context4.prev = 20;
                _context4.t5 = _context4["catch"](4);
                console.error('ERROR', 'DrupalEventDate.loadBookingState', 'loading booking state from server', _context4.t5);
                (0, _MuiAlertHelper.showAlertWithOptions)({
                  title: (0, _DrupalRubricStrings.getString)('ERROR'),
                  message: (0, _ErrorHelper.getErrorMessage)(_context4.t5)
                });

              case 24:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[4, 20]]);
      }));

      function loadBookingState() {
        return _loadBookingState.apply(this, arguments);
      }

      return loadBookingState;
    }()
  }, {
    key: "notifyParent",
    value: function notifyParent() {
      if (this.props.onUpdate) {
        this.props.onUpdate();
      }
    }
    /**
     *
     * @param eventDate {EventDate}
     * @param bookingState
     * @returns {Promise<void>}
     */

  }, {
    key: "bookEventDate",
    value: function bookEventDate(eventDate) {
      var _this2 = this;

      var profileComplete = _config["default"].isUserProfileComplete();

      console.log('INFO', 'DrupalEventDate.bookEventDate', 'bookeventdate', profileComplete);

      if (!profileComplete) {
        var closeDialogFn = (0, _MuiAlertHelper.showAlertWithOptions)({
          size: 'large',
          title: (0, _DrupalRubricStrings.getString)('CONFIRM_BOOKING'),
          centeredContent: false,
          style: {
            minWidth: '400px'
          },
          react: /*#__PURE__*/_react["default"].createElement(_UserProfile["default"], {
            editMode: !profileComplete,
            onDone: function onDone() {
              closeDialogFn();
              setTimeout(function () {
                _this2.bookEventDate(eventDate);
              });
            }
          })
        });
        return;
      }

      var cancelButton = {
        label: (0, _DrupalRubricStrings.getString)('CANCEL'),
        callback: function callback() {}
      };
      var bookingButton = {
        label: (0, _DrupalRubricStrings.getString)('BOOK_NOW'),
        callback: function callback() {
          return _this2.updateBookingStateOnServer(eventDate, BOOKING_STATES.BOOKED);
        }
      };
      (0, _MuiAlertHelper.showAlertWithOptions)({
        size: 'large',
        title: (0, _DrupalRubricStrings.getString)('CONFIRM_BOOKING'),
        centeredContent: false,
        style: {
          minWidth: '400px'
        },
        react: /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalRubric["default"].tableContainer
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalRubric["default"].infoText
        }, (0, _DrupalRubricStrings.getString)('CONFIRM_BOOKING_DETAIL')), this.renderEventDateInformation(eventDate, true), /*#__PURE__*/_react["default"].createElement(_UserProfile["default"], null)),
        buttons: [cancelButton, bookingButton]
      });
    }
  }, {
    key: "showAlertTooLateToCancel",
    value: function showAlertTooLateToCancel() {
      (0, _MuiAlertHelper.showAlertWithOptions)({
        title: (0, _DrupalRubricStrings.getString)('TOO_LATE_TO_CANCEL_TITLE'),
        message: (0, _DrupalRubricStrings.getString)('TOO_LATE_TO_CANCEL_TITLE_MESSAGE')
      });
    }
  }, {
    key: "cancelEventDate",
    value: function cancelEventDate(eventDate) {
      var _this3 = this;

      if (!this.isCancelable(eventDate)) {
        this.showAlertTooLateToCancel();
        return;
      }

      var cancelButton = {
        label: (0, _DrupalRubricStrings.getString)('CANCEL')
      };
      var cancelBookingButton = {
        label: (0, _DrupalRubricStrings.getString)('CANCEL_NOW'),
        callback: function callback() {
          if (!_this3.isCancelable(eventDate)) {
            _this3.showAlertTooLateToCancel();

            return;
          }

          _this3.updateBookingStateOnServer(eventDate, BOOKING_STATES.CANCELED);
        }
      };
      (0, _MuiAlertHelper.showAlertWithOptions)({
        size: 'large',
        title: (0, _DrupalRubricStrings.getString)('CONFIRM_CANCELING'),
        centeredContent: false,
        style: {
          minWidth: '400px'
        },
        react: /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalRubric["default"].tableContainer
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalRubric["default"].infoText
        }, (0, _DrupalRubricStrings.getString)('CONFIRM_CANCELING_DETAIL')), this.renderEventDateInformation(eventDate, true)),
        buttons: [cancelButton, cancelBookingButton]
      });
    }
    /**
     *
     * @param eventDate {EventDate}
     */

  }, {
    key: "isCancelable",
    value: function isCancelable(eventDate) {
      return new Date() < new Date(eventDate.start);
    }
    /**
     *
     * @param eventDate
     * @returns {null|{booked: number, canceled: number, reserved: number, state: string}}
     */

  }, {
    key: "getEventDateStatus",
    value: function getEventDateStatus(eventDate) {
      if (this.state.ownBookingState) {
        console.log('INFO', 'DrupalEventDate.getEventDateStatus', 'has own booking state');
        return this.state.ownBookingState;
      }

      if (this.props.eventDateStates && this.props.eventDateStates[eventDate.uuid]) {
        return this.props.eventDateStates[eventDate.uuid];
      }

      console.log('INFO', 'DrupalEventDate.getEventDateStatus', 'return null booking state');
      return null;
    }
    /**
     * @param eventDate {EventDate}
     */

  }, {
    key: "renderButton",
    value: function renderButton(eventDate) {
      var _this4 = this;

      var isBooked = this.props.isBooked;
      var maxCancelTime = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.MAX_CANCEL_TIME) || 0;
      var eventDateState = this.getEventDateStatus(eventDate);

      if (!isBooked) {
        if (eventDateState && eventDateState.state === BOOKING_STATES.BOOKED) {
          isBooked = true;
        }
      }

      var isNotCancelable = isBooked && new Date().getTime() + maxCancelTime >= new Date(eventDate.start).getTime();
      console.log('INFO', 'DrupalEventDate.renderButton', 'isNotCancelable', new Date().getTime() + maxCancelTime >= new Date(eventDate.start).getTime(), isBooked, maxCancelTime, new Date().getTime() + maxCancelTime >= new Date(eventDate.start).getTime(), new Date().getTime() - maxCancelTime, new Date(eventDate.start).getTime());

      if (isNotCancelable) {
        return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          onClick: function onClick() {},
          disabled: true,
          variant: 'contained'
        }, (0, _DrupalRubricStrings.getString)('TOO_LATE_TO_CANCEL_TITLE'));
      }

      if (!isBooked && new Date().getTime() + maxCancelTime >= new Date(eventDate.start).getTime()) {
        return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          onClick: function onClick() {},
          disabled: true,
          variant: 'contained'
        }, (0, _DrupalRubricStrings.getString)('BOOKING_NOT_POSSIBLE'));
      }

      if (isBooked) {
        if (!this.isCancelable(eventDate)) {
          return null;
        }

        return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          onClick: function onClick() {
            _this4.cancelEventDate(eventDate);
          },
          variant: 'contained'
        }, (0, _DrupalRubricStrings.getString)('CANCEL_BOOKING'));
      }

      if (eventDateState && eventDateState.booked >= eventDate.maxParticipantsCount || eventDate.maxParticipantsCount === 0) {
        return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          onClick: function onClick() {
            _this4.bookEventDate(eventDate);
          },
          disabled: true,
          variant: 'contained'
        }, (0, _DrupalRubricStrings.getString)('ALREADY_BOOKED_OUT'));
      }

      return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: function onClick() {
          _this4.bookEventDate(eventDate);
        },
        variant: 'contained'
      }, (0, _DrupalRubricStrings.getString)('BOOK'));
    }
    /**
     * @param eventDate {EventDate}
     * @param forConfirmation
     */

  }, {
    key: "renderEventDateInformation",
    value: function renderEventDateInformation(eventDate, forConfirmation) {
      var startTimeString = eventDate.start; //2019-07-10T09:00:00

      var endTimeString = eventDate.end; //2019-07-10T17:00:00

      if (startTimeString.slice(-1) !== 'Z' && startTimeString.indexOf('+') < 0) {
        startTimeString += 'Z';
      }

      if (endTimeString.slice(-1) !== 'Z' && startTimeString.indexOf('+') < 0) {
        endTimeString += 'Z';
      }

      var startDate = startTimeString ? new Date(startTimeString) : null;
      var endDate = endTimeString ? new Date(endTimeString) : null;
      var startFormatted;
      var endFormatted;

      if (startDate) {
        startFormatted = (0, _DateTimeHelper.formatDateAndTime)(startDate);
      }

      if (endDate) {
        var dayDiff = (0, _DateTimeHelper.getDayDiff)(startDate, endDate);
        endFormatted = (0, _DateTimeHelper.formatDateAndTime)(endDate, dayDiff === 1);
      }

      var startDateTimeInTable;
      var endDateTimeInTable;

      if (startFormatted) {
        startDateTimeInTable = /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
          className: "".concat(_DrupalRubric["default"].bold, " ").concat(endFormatted ? '' : _DrupalRubric["default"].paddingBottom)
        }, (0, _DrupalRubricStrings.getString)('START_DATE'), ":"), /*#__PURE__*/_react["default"].createElement("td", {
          className: "".concat(_DrupalRubric["default"].bold, " ").concat(endFormatted ? '' : _DrupalRubric["default"].paddingBottom)
        }, startFormatted.dateWithNameShort, ", ", startFormatted.timeString, ' ', startFormatted.timeSuffix));
      }

      if (endFormatted) {
        endDateTimeInTable = /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
          className: "".concat(_DrupalRubric["default"].bold, " ").concat(_DrupalRubric["default"].paddingBottom)
        }, (0, _DrupalRubricStrings.getString)('END_DATE'), ":"), /*#__PURE__*/_react["default"].createElement("td", {
          className: "".concat(_DrupalRubric["default"].bold, " ").concat(_DrupalRubric["default"].paddingBottom)
        }, endFormatted.dateWithNameShort, ", ", endFormatted.timeString, ' ', endFormatted.timeSuffix));
      }

      var nameRow = null;

      if (forConfirmation) {
        var eventSeries = _KESI2Helper["default"].getEventSeriesByEventDateId(eventDate.id);

        if (eventSeries) {
          nameRow = /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
            className: "".concat(_DrupalRubric["default"].bold, " ").concat(_DrupalRubric["default"].paddingBottom)
          }, (0, _DrupalRubricStrings.getString)('EVENT_TITLE')), /*#__PURE__*/_react["default"].createElement("td", {
            className: "".concat(_DrupalRubric["default"].bold, " ").concat(_DrupalRubric["default"].paddingBottom)
          }, eventSeries.title));
        }
      }

      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("table", null, /*#__PURE__*/_react["default"].createElement("tbody", null, nameRow, startDateTimeInTable, endDateTimeInTable, this.renderDocentRow(eventDate), this.renderVenueRow(eventDate), this.renderInfoRaw(eventDate), this.renderDocuments(eventDate), forConfirmation ? null : this.renderAvailabilityRow(eventDate, !forConfirmation))));
    }
    /**
     *
     * @param eventDate {EventDate}
     */

  }, {
    key: "renderDocentRow",
    value: function renderDocentRow(eventDate) {
      if (eventDate.docents.length > 0) {
        var docentsRendered = eventDate.docents.map(function (docentId, index) {
          /**
           * @type Docent
           */
          var docent = _KESI2Helper["default"].getContentById(docentId);

          console.log('INFO', 'DrupalEventDate.renderDocentRow', 'docent', docent);

          if (!docent) {
            return null;
          }

          if (docent.fullName.indexOf('DO NOT DISPLAY') !== -1) {
            return null;
          }

          return /*#__PURE__*/_react["default"].createElement("div", {
            className: index < eventDate.docents.length - 1 ? _DrupalRubric["default"].paddingBottom : null,
            key: "docent_".concat(docentId)
          }, docent.fullName);
        });
        var filteredDocents = docentsRendered.filter(function (docent) {
          return docent !== null;
        });

        if (!filteredDocents || filteredDocents.length === 0) {
          return null;
        }

        return /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
          className: "".concat(_DrupalRubric["default"].bold, " ").concat(_DrupalRubric["default"].paddingBottom)
        }, eventDate.docents.length === 1 ? (0, _DrupalRubricStrings.getString)('DOCENT') : (0, _DrupalRubricStrings.getString)('DOCENTS'), ":"), /*#__PURE__*/_react["default"].createElement("td", {
          className: _DrupalRubric["default"].paddingBottom
        }, filteredDocents));
      }

      return null;
    }
  }, {
    key: "renderInfoRaw",
    value: function renderInfoRaw(eventDate) {
      if (eventDate.info) {
        return /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
          className: _DrupalRubric["default"].paddingBottom,
          colSpan: "2"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "textWrapperNoPadding",
          dangerouslySetInnerHTML: {
            __html: eventDate.info
          }
        })));
      }

      return null;
    }
  }, {
    key: "renderDocuments",
    value: function renderDocuments(eventDate) {
      var _this5 = this;

      if (eventDate.documents && eventDate.documents.length > 0) {
        return /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
          className: _DrupalRubric["default"].paddingBottom,
          colSpan: 2
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalRubric["default"].fileContainer
        }, eventDate.documents.map(function (document) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: "document_".concat(document.name_to_show),
            className: _DrupalRubric["default"].singleFileContainer
          }, document.show_title ? /*#__PURE__*/_react["default"].createElement("div", {
            className: _DrupalRubric["default"].singleFileTitle
          }, document.title) : null, /*#__PURE__*/_react["default"].createElement("div", {
            className: _DrupalRubric["default"].singleFileHeader
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: _DrupalRubric["default"].singleFileName
          }, document.name_to_show), /*#__PURE__*/_react["default"].createElement(_Image["default"], {
            alt: 'Download Icon',
            className: _DrupalRubric["default"].singleFileDownloadButton,
            src: _config["default"].downloadIcon,
            onClick: function onClick() {
              return _this5.downloadDocument(document);
            }
          })), /*#__PURE__*/_react["default"].createElement("div", {
            className: _DrupalRubric["default"].singleFileInfo,
            dangerouslySetInnerHTML: {
              __html: document.info
            }
          }), /*#__PURE__*/_react["default"].createElement("hr", {
            className: _DrupalRubric["default"].singleFileDivider
          }));
        }))));
      }

      return null;
    }
    /**
     *
     * @param eventDate {EventDate}
     */

  }, {
    key: "renderVenueRow",
    value: function renderVenueRow(eventDate) {
      if (eventDate.venues.length > 0) {
        var venuesRendered = eventDate.venues.map(function (venueId, index) {
          /**
           * @type Venue
           */
          var venue = _KESI2Helper["default"].getContentById(venueId);

          return /*#__PURE__*/_react["default"].createElement("div", {
            className: index < eventDate.venues.length - 1 ? _DrupalRubric["default"].paddingBottom : null,
            key: "venue_".concat(venueId)
          }, venue.name, /*#__PURE__*/_react["default"].createElement("div", {
            className: _DrupalRubric["default"].venueAddress,
            dangerouslySetInnerHTML: {
              __html: venue.address
            }
          }));
        });
        return /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
          className: "".concat(_DrupalRubric["default"].bold, " ").concat(_DrupalRubric["default"].paddingBottom),
          style: {
            verticalAlign: 'top'
          }
        }, eventDate.venues.length === 1 ? (0, _DrupalRubricStrings.getString)('VENUE') : (0, _DrupalRubricStrings.getString)('VENUES'), ":"), /*#__PURE__*/_react["default"].createElement("td", {
          className: _DrupalRubric["default"].paddingBottom
        }, venuesRendered));
      }

      return null;
    }
    /**
     *
     * @param eventDate {EventDate}
     * @param addCapacity {boolean}
     * @returns {*}
     */

  }, {
    key: "renderAvailabilityRow",
    value: function renderAvailabilityRow(eventDate, addCapacity) {
      // needs to be done later
      var eventDateState = this.getEventDateStatus(eventDate);
      var totalSeats = eventDate.maxParticipantsCount;
      var freeSeats = eventDateState && eventDateState.booked ? totalSeats - eventDateState.booked : totalSeats;
      var text = addCapacity ? "".concat(freeSeats, " (").concat((0, _DrupalRubricStrings.getString)('OUT_OF'), " ").concat(totalSeats, ")") : freeSeats;
      return /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        className: _DrupalRubric["default"].paddingBottom
      }, (0, _DrupalRubricStrings.getString)('FREE_SEATS'), ":"), /*#__PURE__*/_react["default"].createElement("td", {
        className: _DrupalRubric["default"].paddingBottom
      }, text));
    }
  }, {
    key: "render",
    value: function render() {
      /**
       * @type EventDate
       */
      var eventDate = this.state.content[this.props.eventDateId];
      console.log('INFO', 'DrupalEventDate.render', 'eventDateId', this.props.eventDateId);

      if (!eventDate || eventDate.showPrecondition && (0, _PreconditionChecker.getFailingPrecondition)(eventDate.showPrecondition) !== null) {
        return null;
      }

      console.log('INFO', 'DrupalEventDate.render', 'eventDate', eventDate);
      return /*#__PURE__*/_react["default"].createElement(_Card["default"], {
        className: _DrupalRubric["default"].cardWithMargin
      }, /*#__PURE__*/_react["default"].createElement(_CardContent["default"], null, this.renderEventDateInformation(eventDate, false), this.renderButton(eventDate)));
    }
  }]);
  return DrupalEventDate;
}(_KESI2BasicComponent["default"]);

DrupalEventDate.propTypes = {
  isBooked: _propTypes["default"].bool,
  eventDateId: _propTypes["default"].string.isRequired,
  eventDateStates: _propTypes["default"].object,
  // key is the eventdate's uuid (not usual id)!
  onUpdate: _propTypes["default"].func,
  updateValue: _propTypes["default"].any
};
var _default = DrupalEventDate;
exports["default"] = _default;